import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { PageHeader, Tabs } from "../../../components/ui";
import { useNavigate } from "../../../lib/navigate";

export const Route = createFileRoute("/admin/messages")({
  staticData: { crumb: { label: "Messages", parents: [] } },
  component: MessagesLayout,
});

type Tab =
  | "/admin/messages"
  | "/admin/messages/texting"
  | "/admin/messages/templates"
  | "/admin/messages/opt-outs";

const TABS: { value: Tab; label: string }[] = [
  { value: "/admin/messages", label: "Conversations" },
  { value: "/admin/messages/texting", label: "Texting" },
  { value: "/admin/messages/templates", label: "Templates" },
  { value: "/admin/messages/opt-outs", label: "Opt-outs" },
];

function MessagesLayout() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const current = TABS.slice(1).find((t) => pathname.startsWith(t.value))?.value ?? "/admin/messages";
  return (
    <>
      <PageHeader title="Messages" />
      <Tabs label="Messages" value={current} tabs={TABS} onChange={(to) => navigate({ to })} />
      <Outlet />
    </>
  );
}
